// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__RmRcr","col":"Table_col__1nrW5","fulfillmentStatus":"Table_fulfillmentStatus__34axu","emailCol":"Table_emailCol__1rTyn"};